export default __webpack_public_path__ + "static/texture-rough-paper-2c9713793374c18be7880c1c769537fb.jpg";